import CustomOutlinedInput from "components/CustomOutlinedInput/CustomOutlinedInput";
import { useEffect, useState } from "react";

const KeywordText = ({ value, onChange, onBlur }) => {
    const [inputValue, setInputValue] = useState("");

   useEffect(() => {
        setInputValue(value);
    }, [value]);

    return (
    <CustomOutlinedInput
      value={inputValue}
      placeholder="Enter keyword"
      size="small"
      className="keyword-input no-border-focus"
      onChange={(e) => {
        setInputValue(e.target.value);
      }}
      onBlur={onBlur}
    />
  );
};

export default KeywordText;